import { Pipe, PipeTransform, inject } from '@angular/core';
import {
  UnitLength,
  UnitMeasurement,
  convertValueToUnit,
  lengthUnitColumns,
  measurementUnitColumns,
} from '../misc/functions';
import { BasicStoreService } from '../services/BasicStore/basic-store.service';
import { formatNumber, formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'tablePrettyPrint',
})
export class TablePrettyPrintPipe implements PipeTransform {
  private readonly basicStore = inject(BasicStoreService);
  private readonly translate = inject(TranslateService);

  transform(value: any, columnId?: string): string {
    if (columnId) {
      const settings = this.basicStore.getComponentStore('einstellung');
      if (settings && settings.einstellung) {
        if (lengthUnitColumns.includes(columnId.toLowerCase())) {
          return convertValueToUnit(value as number, UnitLength, 0, settings.einstellung.optUnitLength, false);
        } else if (measurementUnitColumns.includes(columnId)) {
          return convertValueToUnit(value as number, UnitMeasurement, 0, settings.einstellung.optUnitWidth, false);
        }
      }
    }
    switch (typeof value) {
      case 'number':
        return formatter.format(value);
      case 'boolean':
        return value ? '✓' : '✗';
      case 'string': {
        if (value == 'true') return '✓';
        if (value == 'false') return '✗';
        if (
          (value.length == 25 || value.length == 19 || (value.length == 10 && !/[a-zA-Z]/.test(value))) &&
          (value.includes('.') || value.includes('-')) &&
          Date.parse(value)
        ) {
          const dateFormat = !value.includes(':') || value.includes('00:00:00') ? 'shortDate' : 'short';
          return formatDate(value, dateFormat, this.translate.getCurrentLang());
        }
        return value;
      }
    }
    return `${value ?? ''}`;
  }
}

const formatter = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
  useGrouping: false,
});
